import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-24 pb-20 md:pt-32 md:pb-32 overflow-hidden bg-cream" data-id="element-93">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-94">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-95">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="max-w-2xl" data-id="element-96">
            <span className="inline-block text-gold font-semibold tracking-widest text-sm uppercase mb-6" data-id="element-97">
              The Internal De-Bloat Protocol
            </span>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-charcoal leading-[1.1] tracking-tight mb-6" data-id="element-98">
              The 7-Day <br data-id="element-99" />
              <span className="italic text-sage" data-id="element-100">Face Sculpt</span>
            </h1>
            <p className="text-xl md:text-2xl font-serif text-charcoal/80 mb-10 leading-relaxed" data-id="element-101">
              Erase "Stress-Face" and re-define your jawline in 7 days — without
              expensive creams or surgical procedures.
            </p>

            <a href="#offer" className="inline-block" onClick={e => {
            e.preventDefault();
            document.getElementById('offer')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-102">
              <Button data-id="element-103">Reveal My Sculpted Face Now</Button>
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: 'easeOut'
        }} className="relative" data-id="element-104">
            <div className="absolute inset-0 bg-sage/10 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-105"></div>
            <img src="https://cdn.magicpatterns.com/uploads/8xxj11KfY4PVrBduirZ7nU/7_days.png" alt="The 7-Day Face Sculpt Course on multiple devices showing before and after results" className="w-full h-auto rounded-2xl shadow-2xl object-cover" data-id="element-106" />
          </motion.div>
        </div>
      </div>
    </section>;
}